import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //  this.$store.state.$computer
    // 线上的
    $url: "/api",
    $imgUrl: "https://merchant-1317461711.cos.ap-nanjing.myqcloud.com/",
    $JHToken: window.localStorage.getItem("$JHToken")
      ? window.localStorage.getItem("$JHToken")
      : "",
    $JHUser: window.localStorage.getItem("$HJUser")
      ? JSON.parse(window.localStorage.getItem("$HJUser"))
      : {},
    $computer: true,
    $ocr:'/api/support/ocr'
  },
  mutations: {
    // this.$store.commit("Collapse", "");
    token(state, weather) {
      state.$JHToken = weather;
    },
    JHUser(state, weather) {
      state.$JHUser = weather;
    },
    computer(state, weather) {
      state.$computer = weather;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js